import React, { useEffect, useState } from 'react';
import { Box, Flex, Image, Link, Spacer, IconButton } from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import ColorModeToggle from './ColorModeToggle';
import { getNavLinks } from '../data/navigation';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = document.getElementById('hero')?.offsetHeight || 0;
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > heroHeight - 100);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    handleResize(); // Check initial size

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Odkazy se mění v src/data/navigation.ts (VÁNOCE jen do konce akce,
  // DOTAZY jen se zapnutou sekcí FAQ)
  const navLinks = getNavLinks();

  if (isMobile) {
    return (
      <>
        <Box
          className="mobile-navbar-container"
          style={{ display: isVisible ? 'block' : 'none' }}
        >
          <Flex align="center">
            <ColorModeToggle className="mobile-color-toggle" />
            <IconButton
              aria-label="Toggle menu"
              icon={isMobileMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
              onClick={toggleMobileMenu}
              className="hamburger-button"
              size="lg"
              variant="ghost"
              color="white"
            />
          </Flex>
        </Box>
        
        <Box
          className={`mobile-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}
        >
          <Flex className="mobile-menu-links">
            {navLinks.map((link) => (
              <Link key={link.href} href={link.href} className="mobile-menu-link" onClick={toggleMobileMenu}>
                {link.label}
              </Link>
            ))}
          </Flex>
        </Box>
      </>
    );
  }

  return (
    <Box
      as="nav"
      className={`navbar-container ${isVisible ? 'visible' : 'hidden'}`}
    >
      <Flex className="navbar-content">
        <Image src="/photos/whiteLogo2.png" alt="Logo" className="navbar-logo" />
        <Spacer className="navbar-spacer" />
        <Flex className="navbar-links" align="center">
          {navLinks.map((link) => (
            <Link key={link.href} href={link.href} className="navbar-link">
              {link.label}
            </Link>
          ))}
          <ColorModeToggle className="desktop-color-toggle" />
        </Flex>
      </Flex>
    </Box>
  );
};

export default Navbar;
